import { render, staticRenderFns } from "./ConfirmLogin.vue?vue&type=template&id=084f2d42&"
import script from "./ConfirmLogin.vue?vue&type=script&lang=js&"
export * from "./ConfirmLogin.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmLogin.vue?vue&type=style&index=0&id=084f2d42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports